import { create } from "zustand";

import type { DateRangePreset, CustomDateRange } from "@app/analytics/types";

interface DateRangeStateValues {
  comparing: boolean;
  customDateRange: CustomDateRange | null;
  dateRangePreset: DateRangePreset | null;
}

interface DateRangeState extends DateRangeStateValues {
  setComparing: (comparing: boolean) => void;
  setCustomDateRange: (range: CustomDateRange) => void;
  setDateRangePreset: (preset: DateRangePreset) => void;
}

const DEFAULT_STATE: DateRangeStateValues = {
  comparing: false,
  customDateRange: null,
  dateRangePreset: "30",
};

const useDateRangeStore = create<DateRangeState>((set) => ({
  ...DEFAULT_STATE,

  setComparing: (comparing) => set({ comparing }),
  setCustomDateRange: (range) =>
    set({ customDateRange: range, dateRangePreset: null }),
  setDateRangePreset: (preset) =>
    set({ customDateRange: null, dateRangePreset: preset }),
}));

export default useDateRangeStore;
